import { OrgId } from '../../id'

export type DesktopReportsInOrgRequestParams = {
  orgId: OrgId
}

export enum KnownDesktopReport {
  DailyDistribution = 'daily_distribution', // Выдано за день
  DailyOrders = 'daily_orders', //             Заказано на день
  DailySales = 'daily_sales', //               Продано за день
  FundsSales = 'funds_sales', //               Продано по видам средств
  PaymentModeSales = 'payment_mode_sales', //  Продано по способу расчета
  DayBySaleType = 'day_by_sale_type', //  Продано по типу продукции
  DayCash = 'day_cash', //  Продано наличными
}

export const isKnownDesktopReport = (report: string): report is KnownDesktopReport => {
  return Object.values(KnownDesktopReport).includes(report as KnownDesktopReport)
}

export type DesktopReportInOrgInfo = {
  restrictPrint?: boolean
  schoolEnabled: boolean
  supplierEnabled: boolean
  supplierUse: boolean
}

export type DesktopReportInOrgShortInfo = {
  restrictPrint?: boolean
  schoolEnabled: boolean
}

export type DesktopReportInOrgMap = Map<string, DesktopReportInOrgInfo>

export type DesktopReportsInOrgMutateParams = {
  orgIds: Array<OrgId>
  reportsSettings: Record<string | KnownDesktopReport, DesktopReportInOrgShortInfo>
}
